import { createSlice } from "@reduxjs/toolkit";
import { fetchIncomeStatementThunk, fetchBalanceSheetThunk } from "./financialStatements.thunk";

const initialState = {
  incomeStatement: null,
  balanceSheet: null,
  loading: false,
  balanceSheetLoading: false,
  error: null,
};

const financialStatementsSlice = createSlice({
  name: "financialStatements",
  initialState,
  reducers: {
    clearFinancialStatementsState: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Income Statement
      .addCase(fetchIncomeStatementThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIncomeStatementThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.incomeStatement = action.payload?.data || null;
      })
      .addCase(fetchIncomeStatementThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Balance Sheet
      .addCase(fetchBalanceSheetThunk.pending, (state) => {
        state.balanceSheetLoading = true;
        state.error = null;
      })
      .addCase(fetchBalanceSheetThunk.fulfilled, (state, action) => {
        state.balanceSheetLoading = false;
        state.balanceSheet = action.payload?.data || null;
      })
      .addCase(fetchBalanceSheetThunk.rejected, (state, action) => {
        state.balanceSheetLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearFinancialStatementsState } =
  financialStatementsSlice.actions;

export default financialStatementsSlice.reducer;
